import { camelCase } from '../utils'

export default function getPath(app, ...parts) {

  if (app === 'backend') {
    app = ''
  }

  let basePath = `/${app}`

  if (app === 'frontend' && process.env.FRONTEND_URL) {
    basePath = process.env.FRONTEND_URL

    if (basePath.startsWith('//')) {
      const url = new URL(window.location)
      basePath = url.protocol + basePath
    }

    try {
      const url = new URL(basePath)
      // in case the url is valid, get just the path and set it as new basepath
      // eslint-disable-next-line max-depth
      if (url.pathname) {
        basePath = url.pathname
      }
    }
    catch (e) {
      // NOOP
    }

  }

  if (basePath === '/') {
    basePath = ''
  }


  let path = ''

  if (parts.length) {
    path = `${parts.map(part => camelCase(part)).join('/')}`
  }

  let fullPath = `${basePath}/${path.replace(/^\/+/, '')}`

  // Replace all double slashes (excpet for the one following a :) with a
  // single slash
  fullPath = fullPath.replace(/(?:([^:])\/+)/, '$1/')

  if (fullPath.length > 1) {
    fullPath = fullPath.replace(/\/$/, '')
  }

  return fullPath
}



// WEBPACK FOOTER //
// ./src/shared/utils/getPath.js